export default __webpack_public_path__ + "static/media/Messi.48617e8d.jpg";